import { WidgetTitleProps } from '@/types/cms'
import SectionTitle from '@/components/SectionTitle/SectionTitle'
import AdLabel from '@/components/AdLabel/AdLabel'

export default function Title({ item }: Readonly<{ item: WidgetTitleProps }>) {
  const useSectionName = item.model.fields?.useSectionName ?? true
  const title = item.model.fields?.title ?? ''
  const homeSection = item.items?.[0]?.model?.homeSection ?? ''

  return (
    <>
      {item.model.fields?.adLabel && <AdLabel />}
      <SectionTitle title={useSectionName ? homeSection : title} />
    </>
  )
}
